import React from "react";
import Homebanner from "../components/home-components/Homebanner";
import Marqueetext from "../components/home-components/Marqueetext";
import Speciliazation from "../components/home-components/Speciliazation";
import CardCarousel from "../components/home-components/CardCarousel";
import Aboutus from "../components/home-components/Aboutus";
import Projects from "../components/home-components/Projects";
import FooterContactForm from "../components/home-components/FooterContactForm";
import FAQS from "../components/home-components/FAQS";
import Pricing from "../components/home-components/Pricing";
import HowItWorks from "../components/home-components/HowItWorks";
import Education from "../components/home-components/Education";
export default function Homepage() {
  return (
    <div>
      <Homebanner />
      <Marqueetext />
      <Speciliazation />
      <CardCarousel/>
      <Aboutus/>
      <Education/>
      <HowItWorks/>
      <Pricing/>
      <FAQS/>
      <Projects/>
      <FooterContactForm/>
    </div>
  );
}
